import React from 'react';
import {RowType} from "../../models/api/codegen/code";
import styled from "styled-components";
import {Row} from "./Row";
import {CardBody} from "./CardBody";

export const Cards: React.FC<{ row: RowType }> = ({row}) => {

    if (!row.cards) {
        return <></>
    }
    return (
        <CardsGrid>
            {row.cards.map((card, i) => card.type === 'rows' ? (
                <div key={i}>
                    {card.rows && card.rows.map((row, i) => <Row key={i} row={row} />)}
                </div>
            ) : (
                <Card key={i}>
                    {card.title && <h4>{card.title}</h4>}
                    {card.title && <hr/>}
                    <CardBody card={card}/>
                </Card>
            ))}
        </CardsGrid>
    )
}

const CardsGrid = styled.div`
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fit, minmax(300px, max-content));
`;

const Card = styled.div`
    background-color: ${props => props.theme.palette.background.paper};
    border-radius: 10px;
    border: 1px solid ${props => props.theme.palette.border};
    padding: 5px;
    & > div {
        padding: 20px;
    }
    & > table {
        padding: 20px;
    }
    & > h4 {
        padding-left: 20px;
        padding-right: 20px;
    }
`;